<template>
  <modal :show="show" :large="true" v-on:close="closeModal">
    <div slot="title">
      <h4>New Invoice</h4>
    </div>
    <div class="row">
      <div class="col-xl-12">
        <div class="form-horizontal">
          <selectlist
            name="recipient_id"
            placeholder="Please Select"
            label="Recipient"
            v-model="form.recipient_id"
            :options="recipients"
            key-name="id"
          ></selectlist>

          <selectlist
            name="third_party_id"
            placeholder="Please Select"
            label="Third Party"
            v-model="form.third_party_id"
            :options="thirdParties"
            key-name="id"
            label-name="full_name"
          ></selectlist>

          <selectlist
            name="insurer_id"
            placeholder="Please Select"
            label="Insurer"
            v-model="form.insurer_id"
            :options="insurers"
            key-name="id"
            label-name="name"
            :readonly="true"
          ></selectlist>

          <fieldset>
            <legend>Heads Of Claim</legend>

            <div
              class="form-group"
              :key="index"
              v-for="(group, index) in rateGroups"
            >
              <div class="col-lg-4">
                <label class="control-label">{{ group.label }}</label>
              </div>
              <div class="col-lg-8">
                <toggleswitch
                  :name="`rate-groups-${index}`"
                  :checked="selected(group)"
                  @change="toggleGroup(group)"
                ></toggleswitch>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
    </div>
    <div slot="footer">
      <button type="button" v-on:click="closeModal" class="btn btn-danger">
        Close
      </button>
      <form-button :indicator="form.processing()" v-on:clicked="submit">
        Generate Invoice
      </form-button>
    </div>
  </modal>
</template>
<script>
export default {
  props: {
    incident: {
      type: String,
      required: true
    },
    recovery: {
      type: Object,
      required: true
    },
    rateGroups: {
      type: Array,
      required: true
    },
    show: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      form: new window.Form({
        recipient_id: null,
        third_party_id: null,
        insurer_id: null,
        rate_groups: []
      })
    };
  },

  computed: {
    recipients() {
      return this.$store.getters['InvoiceRecipients/all'];
    },

    thirdParties() {
      return this.$store.getters['Incident/thirdParties'];
    },

    client() {
      return this.$store.getters['Incident/client'];
    },

    recipient() {
      return this.recipients.find(
        recipient => recipient.id == this.form.recipient_id
      );
    },

    thirdParty() {
      return this.thirdParties.find(
        thirdParty => thirdParty.id == this.form.third_party_id
      );
    },

    insurer() {
      if (this.recipient) {
        if (this.recipient.name === 'clients_own_insurer') {
          return this.client?.insurance?.insurer?.id;
        } else {
          return this.thirdParty?.insurer?.id;
        }
      }

      return null;
    },

    insurers() {
      return this.$store.getters['Insurers/all'];
    }
  },

  mounted() {
    this.$store.commit('InvoiceRecipients/retrieve');
  },

  methods: {
    closeModal() {
      this.$emit('close');
    },

    submit() {
      this.form
        .post(`/debt-recovery/${this.incident}/invoices`)
        .then(invoice => {
          window.toastify.success(
            'Success',
            'The invoice was generated successfully!'
          );

          this.form.recipient_id = null;
          this.form.third_party_id = null;
          this.form.rate_groups = [];

          this.recovery.invoices.push(invoice);

          this.closeModal();
        })
        .catch(error => {
          window.toastify.error(
            'Sorry, there was a problem adding the payment'
          );
        });
    },

    selected(group) {
      return this.form.rate_groups.includes(group.id);
    },

    toggleGroup(group) {
      if (this.selected(group)) {
        const index = this.form.rate_groups.findIndex(id => id == group.id);

        this.form.rate_groups.splice(index, 1);
      } else {
        this.form.rate_groups.push(group.id);
      }
    }
  },

  watch: {
    insurer(insurer) {
      if (insurer) {
        this.form.insurer_id = insurer;
      }
    }
  }
};
</script>
